import { TenantConfig } from '@/types/TenantConfig'

const black = '#111111'
const white = '#FBF9F0'

export const secretcinema: TenantConfig = {
  logo: 'assets/secretcinema/static/logo.png',

  themeOptions: {
    logoHeight: '30px',
    headerHeight: '54px',
    primaryColor: black,
    secondaryColor: black,
    headerBackground: black,
    memberLinksColor: white,
    cartHeaderBackgroundColor: black,
    footerBackgroundColor: black,
    footerTextColor: white,
    dialog: {
      headerBackground: black,
      headerTextColor: white,
    },
  },
}
